import { Directive, HostListener, Input, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appNumericLimit]',
})
export class NumericLimitDirective {
  @Input('appNumericLimit') maxLength: number = 7;

  constructor(@Optional() private ngControl: NgControl) {}

  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    const forbiddenKeys = ['e', 'E', '.', ',', '+', '-'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  @HostListener('input')
  @HostListener('ionInput')
  onInput() {
    if (!this.ngControl || !this.ngControl.control) return;

    const control = this.ngControl.control;
    if (control.value === null || control.value === '') return;

    const strValue = control.value.toString();

    if (strValue.length > this.maxLength) {
      const slicedValue = strValue.slice(0, this.maxLength);
      control.setValue(Number(slicedValue), { emitEvent: false });
    }
  }
}
